export default "__VITE_ASSET__D1CuN5Zh__"